const defaultState = {
  newUser: {},
  error: null,
  fetching: false,
  fetched: false
};

const addUserReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'ADD_USER_FETCH_PENDING': {
      return {
        ...state, fetching: true, error: null
      };
    }
    case 'ADD_USER_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, error: null, fetched: true, newUser: action.payload
      };
    }
    case 'ADD_USER_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default addUserReducer;


// WEBPACK FOOTER //
// ./src/reducers/addUser.js